var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_4031_9715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.78008 1.66507C4.25948 1.58339 4.75111 1.61033 5.21872 1.74392C5.68633 1.87751 6.118 2.11434 6.48191 2.43694L6.50195 2.45482L6.52037 2.43857C6.86768 2.13377 7.276 1.90654 7.71809 1.77204C8.16017 1.63754 8.62586 1.59885 9.08408 1.65857L9.21733 1.67807C9.79491 1.7778 10.3348 2.03186 10.7797 2.41337C11.2247 2.79487 11.5582 3.28961 11.745 3.84519C11.9317 4.40077 11.9648 4.99651 11.8406 5.56933C11.7164 6.14215 11.4396 6.67072 11.0395 7.09907L10.942 7.19928L10.916 7.22149L6.88058 11.2184C6.78745 11.3106 6.66407 11.3659 6.5333 11.3741C6.40253 11.3822 6.27324 11.3427 6.16937 11.2629L6.11845 11.2184L2.05974 7.19819C1.62978 6.77984 1.324 6.25065 1.17626 5.66921C1.02853 5.08778 1.04461 4.47681 1.22272 3.90395C1.40083 3.33109 1.73402 2.81871 2.18539 2.42355C2.63676 2.02839 3.1887 1.76587 3.78008 1.66507Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4031_9715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.fc6b7927203484ce0edb59e594135f7e.svg";
export { ForwardRef as ReactComponent };